(function () {
  'use strict';

  /* @ngdoc object
   * @name lead
   * @description
   *
   */
  angular
    .module('lead', [
      'ui.router'
    ]);
}());
